import React from 'react';
import { appStoreLink, playStoreLink } from 'src/app/config/appConstants';
import Images from 'src/app/static';

type IProps = {
    isLoginScreen?: boolean
    message?: string
}

const DownloadAppComponent: React.FC<IProps>  = ( {isLoginScreen = true, message}: IProps ) => {
    return (
        <div className={`app-download d-flex flex-column ${!isLoginScreen ? 'mb-0' : ''}`}>
            <div className='mg-y-15'>
                {message && <p className='fs-12 text-black text-center mg-b-5'>{message}</p> }
                <p className='fs-12 text-black text-center mg-b-0'>Download our app for a smoother and more intuitive experience tailored just for you.</p>
                <p className='fs-12 text-black text-center mg-b-0 mg-t-2'>You can sign in using your existing email address and password.</p>
            </div>
            <div className='icons-app'>
                <div className='d-flex align-items-center mx-n-8'>
                    <a href={playStoreLink} target='_blank' rel='noreferrer' className='w-50 pd-x-8'><img src={Images.googlePlay} alt="google-play" className='w-100' /></a>
                    <a href={appStoreLink} target='_blank' rel='noreferrer' className='w-50 pd-x-8'><img src={Images.appleStore} alt="apple-store" className='w-100' /></a>
                </div>
            </div>
        </div>
    )
}   

export default DownloadAppComponent;